import { render, staticRenderFns } from "./StartWorkflowManager.vue?vue&type=template&id=db63b3ba&scoped=true&"
import script from "./StartWorkflowManager.vue?vue&type=script&lang=js&"
export * from "./StartWorkflowManager.vue?vue&type=script&lang=js&"
import style0 from "./StartWorkflowManager.vue?vue&type=style&index=0&id=db63b3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db63b3ba",
  null
  
)

export default component.exports